
import {
  defineComponent,
  onMounted,
  reactive,
  toRefs,
  ref,
  nextTick
} from 'vue'
import { Image, Tab, Tabs, Toast, List, Skeleton, ImagePreview } from 'vant'
import { request } from '@/utils/request'
import { useRoute, LocationQueryValue, useRouter } from 'vue-router'
import qs from 'qs'
import DiglogForm from '@/components/DiglogForm.vue'
import {
  DetailData,
  housetypeData,
  cityInfoData,
  markData
} from '@/api-types.d.ts'
import { Statistical } from './Home.vue'

type Options = Record<string, string | LocationQueryValue[] | null>
interface TabState {
  hxData: {
    housetypelist: housetypeData.Datum[]
    htfinished: boolean
    htloading: boolean
    htpage: number
    parentindex: number
    count: number
  }
  cityInfoData: {
    cityinfolist: cityInfoData.Datum[]
    finished: boolean
    loading: boolean
    page: number
    parentindex: number
    count: number
  }
  markData: {
    marklist: string
    ismore: boolean
  }
}
interface Data {
  say_hello: DetailData.Sayhello | Record<string, never>
  list: Array<DetailData.List & TabState>
  finished: boolean
  loading: boolean
  page: number
  options: Options
}

const statistical = new Statistical()

const getDataVars = (detailData: Data) => {
  const Skeletonloading = ref(true)
  const getData = async () => {
    if (detailData.loading) return
    detailData.loading = true
    try {
      const {
        data: {
          code,
          entry: { data }
        }
      } = await request.get<DetailData.RootObject>(
        '/?site=api&ctl=purchase&act=report&' +
          qs.stringify(detailData.options) +
          '&page=' +
          detailData.page++
      )
      detailData.loading = false
      detailData.finished = (detailData.page - 1) * 3 >= data.count
      if (code == '0') {
        detailData.say_hello = data.say_hello
        detailData.list.push(
          ...data.list.map(item =>
            Object.assign<DetailData.List, TabState>(item, {
              hxData: {
                housetypelist: [],
                htpage: 1,
                htloading: false,
                htfinished: true,
                parentindex: 0,
                count: 0
              },
              cityInfoData: {
                cityinfolist: [],
                page: 1,
                loading: false,
                finished: true,
                parentindex: 0,
                count: 0
              },
              markData: {
                marklist: '',
                ismore: false
              }
            })
          )
        )
        Skeletonloading.value = false
      } else {
        Toast.fail('获取数据失败')
      }
    } catch {
      detailData.loading = false
      Toast.fail('获取数据失败')
    }
  }

  const router = useRouter()
  const visibleFormPopup = ref(false)
  const backhome = () => {
    router.push({ path: '/' })
  }
  const dialogfn = () => {
    visibleFormPopup.value = true
  }
  const route = useRoute()
  onMounted(() => {
    if (route.query.city_en) {
      detailData.options = route.query
      getData()
    } else {
      backhome()
    }
  })

  return {
    dialogfn,
    visibleFormPopup,
    backhome,
    getData,
    Skeletonloading,
    ...toRefs(detailData)
  }
}

const gethtData = (detailData: Data) => {
  const choosetype = reactive({
    hid: '',
    city: '',
    parentindex: 0
  })
  const taboptions = (hid: string, city: string, key: number) => {
    choosetype.hid = hid
    choosetype.city = city
    choosetype.parentindex = key
  }
  const housetypeclick = (value?: number, title?: string) => {
    const list = detailData.list[choosetype.parentindex]
    if (title === '户型介绍' && list.hxData.housetypelist.length < 1) {
      gethtlist(choosetype.parentindex, choosetype.hid, choosetype.city)
    } else if (title === '市场解读' && list.markData.marklist === '') {
      marklist(choosetype.parentindex, choosetype.hid, choosetype.city)
    } else if (
      title === '城市资讯' &&
      list.cityInfoData.cityinfolist.length < 1
    ) {
      cityInfolist(choosetype.parentindex, choosetype.hid, choosetype.city)
    }
  }
  //户型图接口
  const gethtlist = async (value: number, hid: string, city_en: string) => {
    const { hxData: htData } = detailData.list[value]
    try {
      const {
        data: {
          code,
          entry: { data, count }
        }
      } = await request.get<housetypeData.RootObject>(
        '/?site=api&ctl=purchase&act=house_img&city_en=' +
          city_en +
          '&hid=' +
          hid +
          '&page=' +
          htData.htpage++
      )
      htData.parentindex = value
      htData.htfinished = (htData.htpage - 1) * 5 >= count
      htData.htloading = false
      if (code == '0') {
        htData.count = count
        htData.housetypelist.push(...data)
      } else {
        Toast.fail('获取数据失败')
      }
    } catch {
      htData.htloading = false
      Toast.fail('获取数据失败')
    }
  }
  //城市资讯接口
  const cityInfolist = async (value: number, hid: string, city_en: string) => {
    const { cityInfoData: cityInfoData } = detailData.list[value]
    try {
      const {
        data: {
          code,
          entry: { data, count }
        }
      } = await request.get<cityInfoData.RootObject>(
        '/?site=api&ctl=purchase&act=get_new_news&city_en=' +
          city_en +
          '&hid=' +
          hid +
          '&page=' +
          cityInfoData.page++
      )
      cityInfoData.parentindex = value
      cityInfoData.finished = (cityInfoData.page - 1) * 5 >= count
      cityInfoData.loading = false
      if (code == '0') {
        cityInfoData.count = count
        cityInfoData.cityinfolist.push(...data)
      } else {
        Toast.fail('获取数据失败')
      }
    } catch {
      cityInfoData.loading = false
      Toast.fail('获取数据失败')
    }
  }
  //市场解读
  const marklist = async (value: number, hid: string, city_en: string) => {
    const { markData: markData } = detailData.list[value]
    try {
      const {
        data: {
          code,
          entry: { data }
        }
      } = await request.get<markData.RootObject>(
        '/?site=api&ctl=purchase&act=get_market_unscramble&city_en=' +
          city_en +
          '&hid=' +
          hid
      )
      if (code == '0') {
        markData.marklist = data
      } else {
        Toast.fail('获取数据失败')
      }
    } catch {
      Toast.fail('获取数据失败')
    }
    nextTick(() => {
      if (document.getElementsByClassName('cont-warp')[0].clientHeight > 600) {
        markData.ismore = true
      }
    })
  }
  const zkmore = (value: number) => {
    const { markData: markData } = detailData.list[value]
    markData.ismore = !markData.ismore
  }
  return {
    zkmore,
    taboptions,
    housetypeclick,
    gethtlist,
    cityInfolist,
    marklist
  }
}
export default defineComponent({
  name: 'Detail',
  components: {
    DiglogForm,
    Image,
    Tab,
    Tabs,
    List,
    Skeleton
  },
  setup() {
    const route = useRoute()
    onMounted(() => {
      window.city = (route.query.city_en as string) || ''
      window.news_source = 'detail'
      statistical.perform()
    })

    const detailData = reactive<Data>({
      say_hello: {},
      list: [],
      finished: true,
      loading: false,
      page: 1,
      options: {}
    })
    const jump = (city?: string, hid?: string) => {
      window.location.href = `//m.leju.com/touch/house/${city}/${hid}?oc_source=m_zhuanti_fanxiang`
    }
    const jumpurl = (url: string) => {
      window.location.href = url
    }
    const ImagePreviewfn = (img: string) => {
      ImagePreview({
        images: [img]
      })
    }
    return {
      ImagePreviewfn,
      jump,
      jumpurl,
      ...getDataVars(detailData),
      ...gethtData(detailData)
    }
  }
})
